export default __webpack_public_path__ + "locales/en/DeleteThirdPartyDialog.json?hash=3ec1c4620c1525a9de41e02590954792";